module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "a09_prf1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "imagesmmmm"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/lin2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chauthor"
  }, [_c('i', [_vm._v("Romain Cansiere")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARAWA, IWO JIMA, ENIWETOK")]), _vm._v(", and "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PELELIU")]), _vm._v(" are names unfamiliar to the French ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew very little about the Pacific war before starting this project. Although a couple of battles occurred between the Siamese (Thai) forces allied to Japan and the French colonial army, for the French our history sticks to what happened in Europe. We are more familiar with names such as Caen, Bastogne, Saint Lô, and Carentan, Allied victories near the end of the war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Pacific, for the French a forgotten theatre of operations, was interesting to me. Since my English was not of the best (I was then a teenager), I started to read French magazines or website articles. I quickly focused on the battle of Tarawa and the few medium tanks (fourteen) involved in it. Maybe the originality of the unit symbol and the limited number of tanks led me to that choice. I quickly realized that versions of what happened to the “Shermans” on Tarawa were contradictory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I was able to read and write better English, I bought US books and began to go through US websites on the subject. I found even more versions of the story of the tanks involved on Betio. In March 2012, I decided to investigate what really happened to that company. At that time, I contacted the United States National Archives for photos and official documents regarding Charlie Company, First Corps Medium Tank Battalion. I made some interesting discoveries including the Battalion after action report. That was the beginning of an adventure.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("I got in touch with MIA relative Philip Wright. Phil is the nephew of Raymond Barker, the driver of CONDOR, a Third Platoon M4A2 disabled behind enemy lines in the first few hours of the battle. Phil told me the background story of his uncle, and the tragedy it represented for the family. I realized that something had to be done for those men and their families. They need to be remembered for what they sacrificed for their country. Phil quickly convinced me to create a website where we could gather specific information on the medium tanks on Tarawa, and that’s how ")]), _c('a', {
    attrs: {
      "href": "http://www.tanksontarawa.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tanksontarawa.com")]), _vm._v(" was born.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most important research was to interview the last survivors. I contacted Ed Gilbert, who was interested in what I was trying to do. He helped me, and we developed a good friendship. He interviewed veterans and edited the text for the website (English is not my first language) among other things.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The idea to write a book came in the winter of 2012–2013 when Ed suggested we permanently preserve the history of Charlie Company. The plan became concrete by July 2013, when I visited the U.S. and met Ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I carried out more research in the National Archives, at the Marine Corps History Division, and at The National Museum of the Pacific War. I met with Dave Vickers who had carried out research on the tanks. He generously shared results of his work, and took me to the National Museum of the Marine Corps for a private guided tour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed and I compared what we had. It took us many hours to check and re-check what information we had, and decide what more we needed. We wanted to use as much original material as possible from the archives. Together we also interviewed two veterans in person: Joe Woolum and Ed Bale. Those were the most memorable moments of my life. I was becoming aware that this book was taking on more importance not only to me, but to the veterans as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back in France, research took another year, keeping in touch with people I’ve met during my travel and especially Annette Amerman from the Marine Corps History Division. Writing went quickly since Ed is an experienced author and because we had already spent countless hours doing research.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This story was in one sense becoming ours. The more I looked at the company roster, the closer I felt to these men. It’s like I knew them, their\n"), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("\nstory. I felt very honored when Ed Bale wrote on the Tarawa Talk forum: “I was astonished at how much Romain knew about the battle for Betio and the operation of the medium tank company, which I had the good fortune to command. I found him to be one of the most personable and polite young men I have met in a long time. He is a real asset to this forum.”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("Isle sur la Sorgue, Vaucluse, France, December 2014.")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46f51ded","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_prf1.vue
// module id = 81
// module chunks = 0